import React from "react";
import { Container, Col, Row } from "react-bootstrap";
import "./arrow.css";

export default props => {
  return (
    <div class="arrow bounce" >
      <div style={{ height: "25px", width: "25px" }} />
    </div>
  );
};
